import {
  AttachmentDownloadUrlResponse,
  AttachmentDownloadVariant,
  CreateAttachmentData,
  CreateAttachmentResponse,
} from "@facade/contracts";

import { api } from "@facade/api";

export type AttachmentDownloadContext = {
  organizationId?: string;
  projectId?: string;
};

export const attachmentsApi = {
  async create(attachment: CreateAttachmentData) {
    const { data } = await api.post<CreateAttachmentResponse>(
      "/attachments",
      attachment,
    );
    return data;
  },
  async completeUpload(attachmentId: string) {
    const { data } = await api.post(
      `/attachments/${attachmentId}/complete-upload`,
    );
    return data;
  },
  async getUrlById(
    attachmentId: string,
    variant: AttachmentDownloadVariant = "original",
    context?: AttachmentDownloadContext,
  ) {
    const { data } = await api.get<AttachmentDownloadUrlResponse>(
      `/attachments/${attachmentId}/download-url`,
      {
        params: {
          variant,
          organization_id: context?.organizationId,
          project_id: context?.projectId,
        },
      },
    );
    return data;
  },
  async getDownloadUrl(
    projectId: string,
    attachmentId: string,
    variant: string = "",
  ) {
    const { data } = await api.get<{ url: string }>(
      `/projects/${projectId}/attachments/${attachmentId}/download-url`,
      {
        params: {
          variant,
        },
      },
    );
    return data;
  },
  async attachUserAvatar(attachmentId: string) {
    const { data } = await api.post(
      `/attachments/${attachmentId}/attach/user-avatar`,
    );
    return data;
  },
};
